import React, { useState } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";
import { bindActionCreators } from "redux";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import toast from "react-hot-toast";
import QRCode from "react-qr-code";
import moment from "moment";
import _ from "lodash";
import { openRegistration } from "@registrationaction";
import { renderFieldText } from "@basecomponent";
import { DATE_FORMAT, DISPLAY_BROWSER_DATE_FORMAT } from "@datehandle";
import {
  classNames,
  validateEmail,
  checkDateFormatYMD,
  validateEmailDomain,
} from "@utilscommon";
import { WEB_PORTAL_URL, SITE_URL, WEB_FOLDER } from "@constant";

import LocaleStrings from "@language";
import GooglePlay from "../../../assets/image/GooglePlay.png";
import AppStore from "../../../assets/image/AppStore.png";

const AssociateUser = (props) => {
  const {
    eventSettingsData,
    formArray,
    eventData,
    session,
    handleSubmit,
    state,
    appuserdata,
    handleassociateuser,
    index,
    pristine,
    invalid,
    submitting,
  } = props;
  const [openContent, setContentOpen] = useState(true);
  const [displayPasscode, setDisplayPasscode] = useState(false);
  const [loading, setloading] = useState(false);

  const handleAccordion = () => {
    if (openContent) {
      setContentOpen(false);
    } else {
      setContentOpen(true);
    }
  };

  const handleApp = (app) => {
    if (app === "ios") {
      window.open(eventData?.iosappstorelink, "_blank");
    } else {
      window.open(eventData?.androidplaystorelink, "_blank");
    }
  };

  const openWebPortel = () => {
    let eventSeoCode = eventData?.seocode;
    let hostname = window.location.hostname;

    let portal = WEB_PORTAL_URL.replace("{seocode}", eventSeoCode);
    if (!hostname.includes(SITE_URL)) {
      if (eventSeoCode.charAt(eventSeoCode.length - 1) === "/") {
        eventSeoCode = eventSeoCode.slice(0, -1);
      }
      portal = `https://${eventSeoCode}${WEB_FOLDER}`;
    }
    let url = `${portal}/overview`;
    if (
      state?.email &&
      state?.passcode &&
      eventSettingsData?.data?.autologin === true
    ) {
      url = `${portal}/autologin?email=${state?.email}&passcode=${state?.passcode}`;
    }
    window.open(`${url}`, "_blank");
  };

  const onSubmitForm = async (data) => {
    // console.log("data :- ", data);

    let error = validate(data, props);
    if (_.isEmpty(error)) {
      let eventCapacity = eventSettingsData?.data?.eventcapacity;
      let eventWaitlistMode = eventSettingsData?.data?.waitlistmode; // true/false, check the event waitlist mode

      // Check event capacity and not allow user registration if capacity is full
      // if (eventCapacity > 0 && eventWaitlistMode === false) {
      //   let totalAppuser = appuserCount?.data?.totalusers;

      //   if (totalAppuser >= eventCapacity) {
      //     toast.error(LocaleStrings.kEventCapacityFullRegistrationText);
      //     return;
      //   }
      // }

      let values = {
        profileurl: data?.profileurl ?? "",
        firstname: data?.firstname?.trim(),
        lastname: data?.lastname?.trim(),
        email: data?.email?.trim().toLowerCase(),
        interest: data?.interest ? _.uniqBy(data?.interest) : [], // Removing duplicate interest IDs
        isnetworking: data?.isnetworking ?? 0,
      };

      if (data?.rsvpsessions && data?.rsvpsessions?.length > 0) {
        values.rsvpsessions = data?.rsvpsessions ?? [];
      }
      if (data?.companyinfo && data?.companyinfo.length > 0) {
        values.companyinfo = data?.companyinfo ?? "";
      }

      let formData = [];
      _.map(formArray, (form) => {
        let formKey = form?.key;
        let name = form?.name;
        let fieldtype = form?.fieldtype;
        let isReadOnly = form?.isreadonly ?? false;
        let isHidden = form?.hidden ?? false;

        if (
          formKey !== "label" &&
          formKey !== "hyperlink" &&
          formKey !== "paragraph" &&
          formKey !== "section"
        ) {
          if (data.hasOwnProperty(name)) {
            if (formKey === "datepicker") {
              let date = "";
              if (data[name] && data[name] !== "") {
                if (
                  data[name] &&
                  form?.pickertype == "range" &&
                  data[name] !== ""
                ) {
                  data[name] = _.isString(data[name])
                    ? data[name].split(" - ")
                    : [];
                  date = data[name]
                    .map((d) => {
                      if (typeof d === "string" && checkDateFormatYMD(d)) {
                        return moment(new Date(Date.parse(d)))?.format(
                          DATE_FORMAT
                        );
                      } else {
                        return moment(d, DISPLAY_BROWSER_DATE_FORMAT)?.format(
                          DATE_FORMAT
                        );
                      }
                    })
                    .filter((d) => moment(d).isValid()); // Filter out invalid dates

                  date = date?.join(" - ");
                } else {
                  if (data[name] && typeof data[name] === "string") {
                    if (checkDateFormatYMD(data[name])) {
                      let dateParse = new Date(Date.parse(data[name]));
                      date = moment(dateParse).format(DATE_FORMAT);
                    } else {
                      date = moment(
                        data[name],
                        DISPLAY_BROWSER_DATE_FORMAT
                      ).format(DATE_FORMAT);
                    }
                    if (!moment(date).isValid()) {
                      date = "";
                    }
                  } else {
                    date = moment(data[name]).format(DATE_FORMAT);
                  }
                }
              }

              form.value = !isReadOnly && !isHidden ? date : "";
            } else if (formKey === "dropdown") {
              let checkType = typeof data[name];
              let val = "";
              if (checkType === "object") {
                val = data?.[name]?.value ?? "";
              } else {
                val = data?.[name] ?? "";
              }
              form.value = !isReadOnly && !isHidden ? val : "";
            } else if (
              formKey === "dynamicfield" &&
              (name === "interest" || fieldtype === "interest")
            ) {
              // No value need to store here.
            } else {
              form.value = !isReadOnly && !isHidden ? data[name] : "";
              if (formKey === "checkboxes" || formKey === "file") {
                form.value = !isReadOnly && !isHidden ? data[name] : [];
              }
            }
          } else {
            if (formKey === "checkboxes" || formKey === "file") {
              form.value = [];
            } else if (
              formKey === "dynamicfield" &&
              (name === "interest" || fieldtype === "interest")
            ) {
              // No value need to store here.
            } else {
              form.value = "";
            }
          }
        }

        formData.push(form);
      });
      // console.log("formData :- ", checkoutFormData);

      values.eventid = eventData?.eventid;
      values.formid = state?.formid;
      values.responses = JSON.stringify(formData);
      if (state.exhibitorid) {
        values.exhibitorid = state.exhibitorid;
      }
      if (state.sponsorid) {
        values.sponsorid = state.sponsorid;
      }

      // console.log("Final Value :- ", values);
      // return;

      // Get external thankyou page
      let link = "";
      if (eventSettingsData?.data?.thankyoulink) {
        let linkVal = eventSettingsData?.data?.thankyoulink;
        if (linkVal.search("http") === -1) {
          link = `http://${linkVal}`;
        } else {
          link = linkVal;
        }
      }
      setloading(true);
      props.openRegistration(session, values, (response) => {
        // console.log("response :- ", response);
        if (response.success === 1) {
          handleassociateuser();
          setloading(false);
        } else if (response.success === 2) {
          if (response?.errors?.code === "invalid_payload") {
            toast.error(
              _.replace(
                LocaleStrings.kInvalidPayloadText,
                "#missed",
                response?.errors?.resource?.missed
              )
            );
          } else if (response?.errors?.code === "invalid_email") {
            toast.error(LocaleStrings.kInvalidEmail);
          } else if (response?.errors?.code === "invalid_event_checkout") {
            toast.error(LocaleStrings.kInvalidCheckoutFormText);
          } else if (
            response?.errors?.code === "event_registration_date_fail"
          ) {
            toast.error(LocaleStrings.kEventRegDateFailText);
          } else if (response?.errors?.code === "email_domain_not_allowed") {
            toast.error(
              _.replace(
                LocaleStrings.kInvalidEmailDomainText,
                "###DOMAIN###",
                response?.errors?.resource?.domain
              )
            );
          } else if (response?.errors?.code === "user_already_registered") {
            toast.error(LocaleStrings.kUserAlreadyRegisteredText);
          } else if (response?.errors?.code === "organizer_credit_limit_used") {
            toast.error(LocaleStrings.kHostCreditLimitUsedText);
          } else if (response?.errors?.code === "event_capacity_full") {
            toast.error(LocaleStrings.kEventCapacityFullRegistrationText);
          } else if (response?.errors?.code === "capacity_full") {
            toast.error(LocaleStrings.kEventCapacityFullText);
          } else if (response?.errors?.code === "session_seat_full") {
            toast.error(
              _.replace(
                LocaleStrings.kSessionSeatFullText,
                "#sessions",
                response?.errors?.resource?.sessions
              )
            );
          } else if (
            response?.errors?.code ===
            "same_track_multiple_session_rsvp_not_allowed"
          ) {
            toast.error(
              _.replace(
                LocaleStrings.kSameTrackSessionRSVPNotAllowedText,
                "#sessions",
                response?.errors?.resource?.sessions
              )
            );
          } else if (
            response?.errors?.code === "common_time_session_rsvp_not_allowed"
          ) {
            toast.error(
              _.replace(
                LocaleStrings.kCommonTimeSessionRSVPNotAllowedText,
                "#sessions",
                response?.errors?.resource?.sessions
              )
            );
          } else {
            toast.error(LocaleStrings.kUserAlreadyRegisteredText);
          }
          setloading(false);
        } else if (response.success === 3) {
          toast.error(LocaleStrings.kProfilePicNotUploadedText);
        } else {
          toast.error(LocaleStrings.kSomethingWentWrongMsg);
        }
      });
    } else {
      toast.error(LocaleStrings.kRequiredFieldAlert);
      setloading(false);
    }
  };
  let hideAssignDetails =
    JSON.parse(eventSettingsData?.data?.custom_settings ?? "{}")
      ?.hide_applinks_qr ?? false;
  const handlePasscodeDisplay = (action) => {
    setDisplayPasscode(action === "display" ? true : false);
  };
  return (
    <>
      <li className="rounded-md border border-default" key={index}>
        {appuserdata.length == 0 ? (
          <>
            <div
              className={classNames(
                "cursor-pointer py-4 px-4 flex items-center justify-between border-b"
              )}
              onClick={handleAccordion}
            >
              <div className="flex items-center space-x-4">
                <div className="flex space-x-1.5">
                  {LocaleStrings.kAssociateUser}
                </div>
              </div>
              <div className="flex items-center space-x-6">
                {openContent ? (
                  <ChevronUpIcon className="w-5 h-5" />
                ) : (
                  <ChevronDownIcon className="w-5 h-5" />
                )}
              </div>
            </div>

            <div className={`${openContent ? "" : "hidden"}`}>
              <>
                <div className="bg-default px-4 py-4">
                  <form onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="base-form">
                      <>
                        <div className="md:grid grid-cols-4 md:space-x-6 space-y-2 2xs:space-y-4 md:space-y-0">
                          <div className="col-span-2">
                            <Field
                              name={`firstname`}
                              label={LocaleStrings.kFirstName}
                              placeholder={LocaleStrings.kPlaceholderFirstName}
                              type="text"
                              component={renderFieldText}
                              mandatory={true}
                            />
                          </div>
                          <div className="col-span-2">
                            <Field
                              name={`lastname`}
                              label={LocaleStrings.kLastName}
                              placeholder={LocaleStrings.kEnterLastName}
                              type="text"
                              component={renderFieldText}
                              mandatory={true}
                            />
                          </div>
                        </div>
                        <Field
                          name={`email`}
                          label={LocaleStrings.kEmail}
                          placeholder={LocaleStrings.kEnterEmailAddress}
                          type="text"
                          component={renderFieldText}
                          mandatory={true}
                        />
                      </>
                    </div>
                    <div className="mt-4 text-right">
                      <button
                        type="submit"
                        className="theme-button-md"
                        disabled={pristine || invalid || submitting || loading}
                      >
                        <svg
                          className={classNames(
                            loading ? "" : "hidden",
                            "cust-btn-spinner"
                          )}
                          viewBox="0 0 1024 1024"
                          focusable="false"
                          data-icon="btnloading"
                          width="1em"
                          height="1em"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                        </svg>{" "}
                        {LocaleStrings.kRegisterText}
                      </button>
                    </div>
                  </form>
                </div>
              </>
            </div>
          </>
        ) : (
          <>
            <div
              className={`border border-default shadow-md rounded-md sm:grid sm:grid-cols-3 overflow-hidden ASSIGN_TICKETS_INFO`}
              style={hideAssignDetails ? { display: "none" } : {}}
            >
              {/* User QR */}
              {appuserdata?.userqrstring ? (
                <div className="flex items-center justify-center bg-default sm:col-span-1 px-4 py-4 QR_CODE ASSIGN_TICKETS_QR_CODE">
                  <div className="p-4 overflow-hidden border border-default rounded-lg w-60 sm:w-full h-full bg-white">
                    <QRCode
                      size={215}
                      style={{ width: "100%", height: "100%" }}
                      viewBox={`0 0 256 256`}
                      value={appuserdata?.userqrstring ?? ""}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}

              {/* Other info */}
              <div
                className={`bg-white ${
                  state?.qrtoken ? "sm:col-span-2" : "sm:col-span-3"
                } px-4 py-4 ASSIGN_TICKETS_OTHER_INFO`}
              >
                <section aria-labelledby="information-heading">
                  <div className="text-primary text-2xl font-bold ASSIGN_TICKETS_EVENT_NAME break-words">
                    {eventData?.eventname}
                  </div>

                  {/* divider */}
                  <div className="relative py-5 ASSIGN_TICKETS_OTHER_INFO_DIVIDER">
                    <div
                      className="absolute inset-0 flex items-center"
                      aria-hidden="true"
                    >
                      <div className="w-full border-t border-gray-300" />
                    </div>
                  </div>
                  {/* divider */}

                  <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-8 md:space-x-2 mb-3 ASSIGN_TICKETS_USER_INFO">
                    <div className="col-span-3 ASSIGN_TICKETS_ASSIGNED_USERNAME">
                      <div className="custom-text-primary-md-medium">
                        {LocaleStrings.kAttendeeNameText}
                      </div>
                      <div className="custom-text-secondary-md-medium break-words">
                        {appuserdata?.firstname ?? "-"} {appuserdata?.lastname}
                      </div>
                    </div>
                    <div className="col-span-3 ASSIGN_TICKETS_ASSIGNED_EMAIL">
                      <div className="custom-text-primary-md-medium">
                        {LocaleStrings.kEmail}
                      </div>
                      <div className="custom-text-secondary-md-medium break-all">
                        {appuserdata?.email ?? "-"}
                      </div>
                    </div>
                    <div className="col-span-2 ASSIGN_TICKETS_ASSIGNED_PASSCODE">
                      <div className="custom-text-primary-md-medium">
                        {LocaleStrings.kLabelPasscode}
                      </div>
                      <div className="custom-text-secondary-md-medium break-all">
                        {appuserdata?.passcode ? (
                          <div
                            className={classNames(
                              displayPasscode ? "space-x-2.5-" : "space-x-4-",
                              "custom-item-vcenter relative"
                            )}
                          >
                            {displayPasscode ? (
                              <span>{appuserdata?.passcode}</span>
                            ) : (
                              <span className="">******</span>
                            )}

                            {displayPasscode ? (
                              <EyeIcon
                                className="w-5 h-5 cursor-pointer absolute left-16"
                                onClick={() => handlePasscodeDisplay("hide")}
                              />
                            ) : (
                              <EyeSlashIcon
                                className="w-5 h-5 cursor-pointer absolute left-16"
                                onClick={() => handlePasscodeDisplay("display")}
                              />
                            )}
                          </div>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center justify-between py-5 border-t gap-2 mt-6 app-login-button-section APP_LOGIN_BUTTON_SECTION">
                    <div className="space-y-2 md:space-y-0 md:grid md:grid-cols-2 app-stores-buttons APP_STORE_BUTTONS">
                      <img
                        className="col-span-1 cursor-pointer APPSTORE_IMAGE"
                        src={AppStore}
                        alt="AppStore"
                        onClick={() => handleApp("ios")}
                      />
                      <img
                        className="col-span-1 cursor-pointer PLAYSTORE_IMAGE"
                        src={GooglePlay}
                        alt="GooglePlay"
                        onClick={() => handleApp("android")}
                      />
                    </div>

                    <div className="web-login-buttons WEB_LOGIN_BUTTONS">
                      <button
                        className="theme-button-md LOGIN_BUTTON"
                        onClick={openWebPortel}
                      >
                        {LocaleStrings.kLoginPortalText}
                      </button>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </>
        )}
      </li>
    </>
  );
};

const validate = (values, ownProps) => {
  let errors = {};

  let checkoutFormData = ownProps?.checkoutFormData?.data;

  let allowedEmailDomain =
    checkoutFormData?.allowemaildomain &&
    checkoutFormData?.allowemaildomain !== ""
      ? checkoutFormData?.allowemaildomain.trim()
      : "";
  // console.log("validation errors :- ", values);
  let firstname = values?.firstname;
  let lastname = values?.lastname;
  let email = values?.email;
  if (!firstname || firstname?.trim() === "") {
    errors["firstname"] = LocaleStrings.kFieldRequired;
  } else if (firstname && firstname?.search('"') >= 0) {
    errors["firstname"] = LocaleStrings.kDoubleQuotesNotAllowedText;
  }
  if (!lastname || lastname.trim() === "") {
    errors["lastname"] = LocaleStrings.kFieldRequired;
  } else if (lastname && lastname.search('"') >= 0) {
    errors["lastname"] = LocaleStrings.kDoubleQuotesNotAllowedText;
  }
  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.kFieldRequired;
  } else if (email && !validateEmail(email)) {
    errors["email"] = LocaleStrings.kInvalidEmail;
  } else if (email) {
    if (!validateEmailDomain(allowedEmailDomain, email)) {
      let emailDomain = email?.split("@")?.[1];
      errors["email"] = _.replace(
        LocaleStrings.kInvalidEmailDomainText,
        "###DOMAIN###",
        emailDomain
      );
    }
  }
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  // console.log({ arrya: state.checkoutFormData });
  return {
    session: state.session,

    // initialValues: init,
    eventData: state.eventData,
    eventUserCategories: state.eventUserCategories,
    manageTicketsCount: state.manageTicketsCount,
    assignedAttendeeTickets: state.assignedAttendeeTickets,
    assignedAttendeeErrors: state.assignedAttendeeErrors,
    eventSettingsData: state.eventSettingsData,
    // formArray: state.formArray,
    checkoutFormData: state.checkoutFormData,

    // pResponseData,

    formValues: getFormValues(ownProps.form)(state),
    formErrors: state?.form?.[ownProps.form]?.syncErrors ?? {},
    assignflow: state.assignflow,
    clientbuildno: state?.eventData?.buildno ?? 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ openRegistration }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "associateUserForm",
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(AssociateUser)
);
